query allRegions(
  $first: Int,
  $offset: Int,
  $filter: RegionFilter,
  ) {
  regions: allRegions(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      regionMappings: regionMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
      regionId
      regionName
      source
    }
    totalCount
  }
}
